/** Traduções dos códigos do SPED para linguagem de tela. */

export const MESES = [
  'jan',
  'fev',
  'mar',
  'abr',
  'mai',
  'jun',
  'jul',
  'ago',
  'set',
  'out',
  'nov',
  'dez',
];

export const MESES_LONGO = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
];

export const OPERACAO: Record<string, string> = {
  E: 'Entrada',
  S: 'Saída',
};

export const EMISSAO: Record<string, string> = {
  P: 'Emissão própria',
  T: 'Emitida por terceiros',
};

/** Modelos de documento fiscal eletrônico (tabela da Receita). */
export const MODELO: Record<string, string> = {
  '55': 'NF-e',
  '65': 'NFC-e',
  '57': 'CT-e',
  '67': 'CT-e OS',
  '59': 'CF-e',
  '58': 'MDF-e',
};

/**
 * Situação do documento (campo COD_SIT do registro C100).
 *
 * Importa na hora de baixar: documento cancelado ou denegado não tem XML
 * autorizado para consulta, e gastar chamada com ele é desperdício.
 */
export const SITUACAO: Record<string, string> = {
  '00': 'Regular',
  '01': 'Regular — extemporâneo',
  '02': 'Cancelado',
  '03': 'Cancelado — extemporâneo',
  '04': 'Denegado',
  '05': 'Numeração inutilizada',
  '06': 'Complementar',
  '07': 'Complementar — extemporâneo',
  '08': 'Regime especial / norma específica',
};

/** Situações sem XML disponível — a tela avisa antes de o usuário gastar cota. */
export const SITUACOES_SEM_XML = new Set(['02', '03', '04', '05']);

export const TIPO_SPED: Record<string, string> = {
  EFD_ICMS_IPI: 'EFD ICMS/IPI',
  EFD_CONTRIBUICOES: 'EFD Contribuições',
  ECD: 'ECD',
  ECF: 'ECF',
  DESCONHECIDO: 'Não reconhecido',
};

export function rotuloCompetencia(chave: string): string {
  const [ano, mes] = chave.split('-');
  return mes ? `${MESES_LONGO[Number(mes) - 1]}/${ano}` : ano;
}

/** Situação da análise para a etiqueta da tela (o enum vem em caixa alta). */
export const STATUS_ANALISE: Record<
  string,
  { texto: string; tom: 'ok' | 'erro' | 'info'; pulsando?: boolean }
> = {
  CONCLUIDA: { texto: 'Concluída', tom: 'ok' },
  PROCESSANDO: { texto: 'Processando', tom: 'info', pulsando: true },
  ERRO: { texto: 'Falhou', tom: 'erro' },
};
